/* ============
 * Home Index Page
 * ============
 *
 * The home index page
 */

import store from '@/store';
import productService from '@/services/product';
import Vue from 'vue';

export default {
  components: {
    VLayout: require('@/layouts/default/default.vue'),
  },
  data() {
    return {
      form: {
        name: '',
        refCode: '',
        type: '',
        price: 0,
        retailPrice: 0,
        remark: '',
        brand: '',
        images: [],
        size: '',
        color: '',
      },
      field: {},
    };
  },
  mounted() {
    this.fetchProduct();
  },
  props: ['id'],
  computed: {
  },
  methods: {
    async onSubmit(form) {
      try {
        await productService.edit(form);
        Vue.router.push({ name: 'product.view' });
      } catch (e) {
        console.error(e);
      }
    },
    async fetchTypes() {
      store.dispatch('type/getTypes', {});
    },
    async fetchProduct() {
      const product = await productService.getOne(this.id, {
        filter: {
        },
      });

      delete product.status;
      this.form = product;
    },
    navigate(data) {
      Vue.router.push(data);
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/product/edit/index.js